export function scrollWithOffset(element) {
  const bodyTop = document.body.getBoundingClientRect().top;
  const headerOffset =
    (document.querySelector("#navbar-basic")?.getBoundingClientRect()?.height ??
      100) + 30;
  const elementTop = element.getBoundingClientRect().top;
  const offsetPosition = elementTop - bodyTop - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
}
